import { render } from "./ActsSummary.vue?vue&type=template&id=4609d899"
import script from "./ActsSummary.vue?vue&type=script&lang=js"
export * from "./ActsSummary.vue?vue&type=script&lang=js"

import "./ActsSummary.vue?vue&type=style&index=0&id=4609d899&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__